/**
 * Purchase Flow shared block scripts
 * This file gets shared between the
 * theme and editor.
 */

// import dependencies
import { setupAutoHeightAni } from '../../util/auto-height'

// for each flow (likely just one)
document.querySelectorAll('.flow')?.forEach((flow) => {
	// cache dom nodes
	const cards = flow.querySelectorAll('.flow__card')
	const select = flow.querySelector('.flow__select--doors')
	const items = flow.querySelectorAll('.flow__item')
	const back = flow.querySelector('.flow__back')
	const selectOpt = select.innerHTML
	let active = { type: '', count: '' }
	// reorganize some things in JS (makes it much easier for the client to edit via Gutenberg)
	const reorg = () => {
		items.forEach((item) => {
			const cta = item.querySelector('.flow__cta')
			if (cta) {
				item.parentNode.insertBefore(cta, item.nextElementSibling)
			}
		})
	}
	reorg()
	// set URLs
	const setUrl = (type) => {
		const url = new URL(window.location)
		if (type) {
			url.searchParams.set('type', type)
		} else {
			url.searchParams.delete('type')
		}
		window.history.replaceState({}, '', url)
	}
	// activate appropriate item (and disable others)
	const coordinateItems = () => {
		flow.classList.remove('has-active-item')
		items.forEach((item) => {
			if (active.type === item.dataset.type && active.count === item.dataset.count) {
				item.classList.add('is-active-item')
				flow.classList.add('has-active-item')
			} else {
				item.classList.remove('is-active-item')
			}
		})
	}
	// activate property type cards on click
	cards.forEach((cardButton, i) => {
		const { type } = cardButton.dataset
		if (type) {
			cardButton.addEventListener('click', () => {
				const doors = cardButton.dataset.counts.split('~')
				select.innerHTML = `${selectOpt}${doors.map((it) => `<option value="${it}">${it}</option>`)}`
				cards.forEach((card) => {
					active.type = type
					card.classList.toggle('is-active-type', cardButton === card)
					flow.classList.add('has-active-type')
					flow.setAttribute('data-active-item', i + 1)
					coordinateItems()
				})
				back.scrollIntoView({ behavior: 'smooth' })
				setUrl(type)
			})
		}
	})
	// activate doors on select box choice
	select.addEventListener('change', () => {
		if (select.value) {
			active.count = select.value
			flow.classList.add('has-active-count')
			coordinateItems()
		}
	})
	// go back to all property types on click of back
	back.addEventListener('click', () => {
		cards.forEach((card) => {
			active = { type: '', count: '' }
			card.classList.remove('is-active-type')
			flow.classList.remove('has-active-item')
			flow.removeAttribute('data-active-item')
			items.forEach((item) => {
				item.classList.remove('is-active-item')
			})
			select.value = ''
			select.dispatchEvent(new Event('change'))
			setUrl(null)
		})
	})
	// establish auto height (for expand animation)
	setupAutoHeightAni('.flow__item-frame')
	setupAutoHeightAni('.flow__cta .wp-block-group__inner-container')
	setupAutoHeightAni('.flow-intro')
	// activate appropriate item on page load if ?type=something
	const preActivate = () => {
		const url = new URL(window.location)
		const type = url.searchParams.get('type')
		if (type) {
			;[...cards].find((card) => card.dataset.type === type)?.click()
		}
	}
	preActivate()
})
